import React, { memo } from 'react';

// import moment from 'moment';
import { useQuery } from '@tanstack/react-query';

import Table from '../../Table';

import ReportService from '../../../services/ReportService';

const cols = [
  {
    title: 'Date',
    keys: ['date'],
    type: 'date',
  },
  {
    title: 'Amount',
    keys: ['amount'],
    type: 'currency',
  },
  {
    title: 'Status',
    keys: ['status'],
  },
  {
    title: 'Name',
    keys: ['name'],
  },
  {
    title: 'Loan',
    keys: ['_loan._property.address_line_1'],
    link: (row) => `/loans/${row.loan_id}?tab=Property`,
  },
  {
    title: 'Parent Amount',
    keys: ['_parent.amount'],
    type: 'currency',
    link: (row) => {
      if (!row?._parent?.id) {
        return null;
      }

      return `/billcom-settlements/${row._parent.id}`;
    },
  },
];

function UnmatchedSettlementsTable() {
  const { data: unmatchedSettlements } = useQuery({
    queryKey: ['unmatchedSettlements'],
    queryFn: ReportService.getUnmatchedSettlements,
  });

  if (!unmatchedSettlements || !unmatchedSettlements.length) {
    return null;
  }

  return (
    <Table
      cols={cols}
      rows={unmatchedSettlements}
      title="Unmatched Settlements"
    />
  );
}

export default memo(UnmatchedSettlementsTable);
